import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Problems from "@/components/site/Problems";
import Solution from "@/components/site/Solution";
import Architecture from "@/components/site/Architecture";
import MetodoSapientia from "@/components/site/MetodoSapientia";
import Services from "@/components/site/Services";
import Differentials from "@/components/site/Differentials";
import HowWeWork from "@/components/site/HowWeWork";
import Technology from "@/components/site/Technology";
import CtaBanner from "@/components/site/CtaBanner";
import DiagnosticForm from "@/components/site/DiagnosticForm";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import { Toaster } from "@/components/ui/sonner";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="antialiased">
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Problems />
        <Solution />
        <Architecture />
        <MetodoSapientia />
        <Services />
        <Differentials />
        <HowWeWork />
        <Technology />
        <CtaBanner />
        <DiagnosticForm />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            borderRadius: 2,
            border: "1px solid #e7e7e7",
            fontFamily: "var(--font-sans)",
          },
        }}
      />
    </div>
  );
}
